import React, { useContext, useEffect, useRef, useState } from 'react';
import { BackgroundContext } from '../../libs/BackgroundProvider';
import { useGameContext } from "../../libs/GameProvider";
import CountDown from '../game-common/CountDown';
import GameGunpowderGameLane from './GameGunpowderGameLane';
import GameGunpowderHintsAndDescriptionModal from './GameGunpowderHintsAndDescriptionModal';
import GameGunpowderPreGame from './GameGunpowderPreGame';

interface GameGunpowderGameProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish?: () => void;
}

function GameGunpowderGame(props: GameGunpowderGameProps) {
  const { setBg } = useContext(BackgroundContext);
  const { game, dispatch } = useGameContext();
  const [started, setStarted] = useState(false);
  const [lives, setLives] = useState(3);
  // const [stepRandomPosition, setStepRandomPosition] = useState([1, 2, 3, 4, 5, 6].sort(() => .5 - Math.random()));
  // const [barItemsState, setBarItemsState] = useState<Array<'ready' | 'fail' | 'success'>>(['ready', 'ready', 'ready', 'ready', 'ready', 'ready',]);
  const successCount = useRef(0);
  // const currentStep = useRef(1);

  useEffect(() => {
    console.log(game);
    if ('game-gunpowder' === game.status) {
      setBg(null);
    }
  }, [game, setBg]);

  const onLaneSuccess = (laneIndex: number) => () => {
    successCount.current += 1;
    if (3 === successCount.current) {
      setTimeout(() => {
        dispatch({ type: 'game-gunpowder', state: 'success' });
      }, 300);
    }
  }

  const onLaneFail = (laneIndex: number) => () => {
    if (1 === lives) {
      dispatch({ type: 'game-gunpowder', state: 'fail' })
    } else {
      setLives(l => l - 1);
    }
  }

  const timesout = () => {
    dispatch({ type: 'game-gunpowder', state: 'fail' })
  }

  const onIntroFinish = () => {
    setStarted(true);
  }

  return (
    <div className="fullscreen">
      <div className="">
        <CountDown started={started} stopped={false} timesout={timesout}></CountDown>
        <GameGunpowderHintsAndDescriptionModal lives={lives} />

        <GameGunpowderGameLane lane={0} onSuccess={onLaneSuccess(0)} onFail={onLaneFail(0)} />
        <GameGunpowderGameLane lane={1} onSuccess={onLaneSuccess(1)} onFail={onLaneFail(1)} />
        <GameGunpowderGameLane lane={2} onSuccess={onLaneSuccess(2)} onFail={onLaneFail(2)} />

        <GameGunpowderPreGame onFinish={onIntroFinish} />
      </div>
    </div>
  )
}

export default GameGunpowderGame;
